<template>
    <footer class="app_footer">
        <div class="iconfont">
            <span v-if="gsinfo.lxdh">联系电话：{{ gsinfo.lxdh }}</span>
            <span style="margin: 0 60px;" v-if="gsinfo.gsdz">公司地址：{{ gsinfo.gsdz }}</span>
            <span>CopyRight © {{ gsinfo.gsmc }}</span>
        </div>
    </footer>
</template>
<script>

export default ({
    name: "Footer",
    created() {
        this.dwinfo = JSON.parse(localStorage.getItem("dwinfo"))
        this.getGs()
    },
    data() {
        return {
            gsinfo: {}
        }
    },
    methods: {
        async getGs() {
            const backData = await this.$API.HKAPI({
                type: "getgsxx",
            });
            if (backData.data.gsbh) {
                this.gsinfo = backData.data;
            }
        },
    }
})
</script>

<style scoped lang='less'>
.app_footer {
    background-color: #333;
    height: 50px;
    line-height: 50px;
    text-align: center;

    .iconfont {
        font-size: 14px;
        display: block;
        color: #666;
    }

}
</style>